import React from "react"
import BoundedInput from "../../../InputForm/BoundedForm"

class InvestmentThemeFormComponent extends React.Component {

	render() {
    const ids          = {
			name        : "ppi-theme-name",
			user				: "ppi-user"
		}

		return (
			<form onSubmit={this.props.onSubmit}>
				{ this.props.delete
					? <div>Êtes-vous sûr de vouloir supprimer le thème <strong>{this.props.theme.name}</strong> ?</div>
					: <div className="columns is-desktop">
							<div className="column is-three-fifths-desktop">
								{ this.props.parentTheme
									?	<p className="field is-horizontal">
											<span className="field-label is-normal">
												<label className="label" htmlFor={ids.name}>Thématique parente</label>
											</span>
											<span className="field-body">
												{this.props.parentTheme.name}
											</span>
										</p>
									: null
								}
								<div className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor={ids.name}>Nom de la thématique</label>
									</span>
									<span className="field-body">
										<span className="field">
											<span className="control">
												<BoundedInput
													className   = "input"
													id          = {ids.name}
													name        = "name"
													min="0"
													max="30"
													recommendedMax="30"
													onChange    = {this.props.onNameChange}
													placeholder = "Nom de la thématique"
													type        = "text"
													value       = {this.props.name}
													required />
											</span>
										</span>
									</span>
								</div>
								{ this.props.parentTheme
									? null
									: <p className="field is-horizontal">
											<span className="field-label is-normal">
												<label className="label" htmlFor={ids.user}>Responsable</label>
											</span>
											<span className="field-body">
												<span className="field has-addons has-addons-right">
													<span className={`select is-fullwidth ${this.props.submitting ? "is-loading" : ""}`}>
														<select 
															disabled    = {this.props.submitting}
															id={ids.user}
															name="user"
															onChange={this.props.onUserChange}
															value={this.props.user}
															required>
															<option value="">Sélectionnez un utilisateur</option>
															{this.props.users.map(user => (
																<option value={user.id}>{user.firstName + " " + user.lastName}</option>
															))}
														</select>
													</span>
												</span>
											</span>
										</p>
								}
							</div>
						</div>
				}
				<div className="columns">
					{/* !this.props.submitting
						? <div className="column">
								<button className={`button is-secondary ${this.props.submitting ? "is-loading" : ""}`}>
									Annuler
								</button>
							</div>
						: null
					*/}
					<div className="column">
						<button className={`button is-primary ${this.props.submitting ? "is-loading" : ""}`}>
							{this.props.delete ? "Supprimer" : (this.props.theme ? "Modifier" : "Ajouter")} le thème
						</button>
					</div>
				</div>
			</form>
		)
	}

}

export default InvestmentThemeFormComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/theme-form-component.js